import React, { useContext } from "react";
import { GraphicalViewerMapContext } from "../context/GraphicalViewerMapContext";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Button from "../../components/Button";
import { TrashIcon } from "@heroicons/react/outline";

export default function GVImageList() {
    const { files, setGraphicalViewerMapContext, reorderImages } = useContext(
        GraphicalViewerMapContext
    );

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        if (result.destination.index === result.source.index) {
            return;
        }

        const newFiles = reorder(
            files,
            result.source.index,
            result.destination.index
        );

        reorderImages(newFiles);

        setGraphicalViewerMapContext((prev) => {
            return { ...prev, files: newFiles };
        });
    }

    return (
        <>
            {files.length > 0 && (
                <aside className="space-y-2 w-96">
                    <div className="flex flex-col" style={{ height: 500 }}>
                        <p className="mb-2 text-gray-500">
                            Drag cards in the order you'd like them to appear in
                            the&nbsp;auction.
                        </p>
                        <div className="pr-4 overflow-y-scroll">
                            <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId="list">
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                        >
                                            <FileList
                                                files={files}
                                                editTract={(file) =>
                                                    setGraphicalViewerMapContext(
                                                        (prev) => {
                                                            const colorizedFile =
                                                                prev.colorizedFiles.find(
                                                                    (img) =>
                                                                        img.id ===
                                                                        file.id
                                                                );
                                                            return {
                                                                ...prev,
                                                                currentMapFile:
                                                                    file,
                                                                graphicalViewerMapShowing: true,
                                                                currentColorizedFile:
                                                                    colorizedFile
                                                                        ? colorizedFile
                                                                        : null,
                                                            };
                                                        }
                                                    )
                                                }
                                            />
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </div>
                    </div>
                </aside>
            )}
        </>
    );
}

const FileList = React.memo(function FileList({ files, editTract }) {
    if (files.length === 0) {
        return <p>No Files!</p>;
    }
    return files.map((file, index) => (
        <ImageCard
            file={file}
            index={index}
            key={file.id}
            editTract={(file) => editTract(file)}
        />
    ));
});

const ImageCard = ({ file, index, editTract }) => {
    const { deleteGraphicalViewerImage } = useContext(
        GraphicalViewerMapContext
    );
    return (
        <Draggable draggableId={file.id} index={index}>
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className="flex w-full px-3 py-1 my-2 bg-gray-100 border border-gray-200 rounded"
                >
                    <div className="overflow-hidden max-w-4 h-14">
                        <img
                            src={file.preview}
                            className="block w-auto h-14"
                            alt=""
                        />
                    </div>
                    <div className="ml-2">
                        <p
                            className="overflow-hidden overflow-ellipsis whitespace-nowrap"
                            style={{ maxWidth: 272 }}
                        >
                            {file.name}
                        </p>
                        <Button
                            size="xs"
                            className="inline"
                            onClick={() => editTract(file)}
                        >
                            Edit GV Data
                        </Button>
                    </div>
                    <button
                        className="ml-auto"
                        onClick={() =>
                            deleteGraphicalViewerImage(file.id, file.preview)
                        }
                    >
                        <TrashIcon className="w-6 h-6 text-gray-700 hover:text-red-700" />
                    </button>
                </div>
            )}
        </Draggable>
    );
};
